import ManualBillingDocument from '@/generated/classes/ManualBillingDocument';
export default class ManualBillingDocumentExtend extends ManualBillingDocument {
  constructor() {
    super();
  }
}
